import { motion } from "framer-motion";
import { ScrollText, Ban, RefreshCcw, Wrench, Phone } from "lucide-react";

const SECTIONS = [
  {
    icon: Ban,
    title: "1. Cancellations & Changes",
    body: "Once you approve your artwork proof and submit payment, your order immediately moves into our software preprocessing pipeline. No cancellations, order modifications, or layout changes can be made after this point.",
  },
  {
    icon: RefreshCcw,
    title: "2. Refunds & Exchanges",
    body: "We do not accept returns, refunds, or exchanges due to customer ordering errors (such as selecting the wrong size garment, choosing the wrong vinyl material, or uploading low-resolution file prints).",
  },
  {
    icon: Wrench,
    title: "3. Damage / Printing Defects",
    body: "If your custom merchandise arrives with a clear manufacturing defect or a structural printing error on our part, please contact us at (876) 298-0309 within 48 hours of pickup or courier delivery alongside photo proof so we can expedite a free reprint.",
  },
];

const Terms = () => (
  <div data-testid="terms-page" className="mx-auto max-w-3xl px-4 pb-24 pt-40 sm:px-6">
    <p className="font-mono text-xs uppercase tracking-[0.4em] text-brand-yellow">The Fine Print</p>
    <h1 className="mt-2 font-display text-4xl font-black uppercase tracking-tight text-white sm:text-6xl">
      Terms & Cancellation Policy
    </h1>

    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="mt-10 border-2 border-brand-yellow/60 bg-brand-yellow/5"
    >
      <div className="flex items-center gap-3 border-b border-brand-yellow/30 bg-brand-yellow/10 px-6 py-4">
        <ScrollText className="h-6 w-6 shrink-0 text-brand-yellow" />
        <h2 className="font-display text-xl font-black uppercase tracking-wide text-brand-yellow">
          🛍️ Custom Order Policy — Please Read Carefully
        </h2>
      </div>
      <p className="px-6 pt-5 text-sm leading-relaxed text-zinc-200">
        Because all items at TLF DESIGNZ are custom-made, personalized, and printed to order with
        your unique artwork, <span className="font-bold text-white">all sales are final</span>.
      </p>
      <div className="space-y-6 px-6 py-6">
        {SECTIONS.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="flex gap-4 border border-white/10 bg-ink-2 p-5"
            data-testid={`terms-section-${i + 1}`}
          >
            <s.icon className="mt-1 h-6 w-6 shrink-0 text-brand-cyan" strokeWidth={1.5} />
            <div>
              <h3 className="font-display text-base font-bold uppercase tracking-wide text-white">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-zinc-400">{s.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
      <div className="border-t border-white/10 px-6 py-4">
        <a
          href="tel:+18762980309"
          data-testid="terms-phone-link"
          className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-brand-cyan transition-colors hover:text-brand-yellow"
        >
          <Phone className="h-4 w-4" /> Questions? Call (876) 298-0309
        </a>
      </div>
    </motion.section>
  </div>
);

export default Terms;
